import { GENERIC_STATUS } from "../../../utils/constants";

export const USER_STATUS_COLORS = {
    [GENERIC_STATUS['ACTIVE']]: {
        BG_COLOR: "rgba(20, 178, 55, 0.1)",
        TEXT_COLOR: "#14B237",
        BOX_SHADOW_COLOR: "#14B237"
    },
    [GENERIC_STATUS['REGISTERED']]: {
        BG_COLOR: "rgba(221, 200, 10, 0.1)",
        TEXT_COLOR: "#D3C00D",
        BOX_SHADOW_COLOR: "#DDC80A"
    },
    [GENERIC_STATUS['INACTIVE']]: {
        BG_COLOR: "rgba(220, 38, 38, 0.1)",
        TEXT_COLOR: "#DC2626",
        BOX_SHADOW_COLOR: "#DC2626"
    }
}